module.exports = __webpack_public_path__ + "media/images/icon-search-off-1ef2f5065465bcb07b9b955cb2640f0e.svg";